import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthFallback } from '../hooks/useAuthFallback';
import { LINKEDIN_CONFIG } from '../constants';
import { toast } from 'react-toastify';
import './VideoCallPage.css';
import './LinkedInCallback.css';
import './HomePage.css';
import './CreditFeaturesList.css';

const LinkedInCallback: React.FC = () => {
  const navigate = useNavigate();
  const { loginWithLinkedIn } = useAuthFallback();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const error = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');



        if (error) {
          console.error('LinkedIn OAuth error:', error, errorDescription);
          toast.error(`LinkedIn login failed: ${errorDescription || error}`);
          navigate('/login');
          return;
        }

        if (code && state) {

          
          // Verify state matches what we stored
          const storedState = sessionStorage.getItem('linkedin_auth_state');
          if (storedState && storedState !== state) {
            console.error('LinkedIn state mismatch');
            toast.error('LinkedIn authentication failed: Invalid state');
            navigate('/login');
            return;
          }

          // Clean up stored state
          sessionStorage.removeItem('linkedin_auth_state');
          
          // Directly authenticate with LinkedIn
          const redirectUri = LINKEDIN_CONFIG.REDIRECT_URL || window.location.origin + '/technbuddy/callback';
          await loginWithLinkedIn(code, redirectUri);
          
        } else {
          console.error('LinkedIn Callback - Missing code or state:', { code, state });
          toast.error('LinkedIn authentication failed: No authorization code received');
          navigate('/login');
        }
      } catch (error) {
        console.error('LinkedIn callback error:', error);
        toast.error('LinkedIn authentication failed. Please try again.');
        navigate('/login');
      }
    };

    handleCallback();
  }, [navigate, loginWithLinkedIn]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '4px solid #e3e3e3',
          borderTop: '4px solid #0077b5',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px'
        }}></div>
        <h3 style={{ color: '#0077b5', marginBottom: '10px' }}>Processing LinkedIn Authentication</h3>
        <p style={{ color: '#666', margin: 0 }}>Please wait while we complete your login...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default LinkedInCallback;